import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import getPhoenixUrlParams from '../lib/get-phoenix-url-params'

import { useCreateOrderFromCartHandlerCreateOrderFromCartMutation } from '../graphql'
import LoadingPage from './LoadingPage'

interface Props {
  skipConfirmation: boolean
}

const CreateCartFromOrderHandler: React.FC<React.PropsWithChildren<Props>> = ({ skipConfirmation }) => {
  const location = useLocation()
  const history = useHistory()
  const { cartId } = getPhoenixUrlParams(location.search)

  const [createOrderFromCart, { data, error }] = useCreateOrderFromCartHandlerCreateOrderFromCartMutation({
    variables: { cartId: cartId as string },
  })

  useEffect(() => {
    // eslint-disable-next-line  @typescript-eslint/no-floating-promises
    createOrderFromCart()
  }, [])

  if (error) {
    throw new Error(`Error creating Order: ${error.message}`)
  }

  if (data) {
    const expectedError = data.createOrderFromCart.__typename === 'ExpectedErrors' && data.createOrderFromCart.errors[0]

    // In this case we just want to treat the expected error the same as a normal one
    // Due to always being a breaking error for the order creation
    if (expectedError) {
      throw new Error(expectedError.message)
    }

    const orderId = data.createOrderFromCart.__typename === 'Order' && data.createOrderFromCart.id
    history.replace(`?orderId=${orderId}&skipConfirmation=${skipConfirmation}`)
  }

  return <LoadingPage />
}

export default CreateCartFromOrderHandler
